'use strict';

const { queryFirst, addClass, removeClass, hasClass, matchesBreakpoint } = require('../domUtil');
const { getNestedValue } = require('../util');
const { selectStyleMessageTmpl, ispuSelectStyleMessageTmpl } = require('../templates').productDetail;

/**
 * Function to check if shipping preferences view is enabled or not
 * @returns { boolean } - returns isEnabled flag value
 */
function isShippingPreferencesViewEnabled() {
    return getNestedValue(window, 'johnnyWasUtils.shippingPreferencesConfig.isEnabled') || false;
}

/**
 * This method manages Notify me container content
 * @param {Object} productData - Product data
 * @param {Object} productContainer - Product Container DOM element
 */
function handleNotifyMe(productData, productContainer) {
    const $body = $('body');
    const addToCartSection = queryFirst('.prices-add-to-cart-actions', productContainer);
    const notifyContainer = queryFirst('.notify-me-container', productContainer);
    const notifyMeButton = queryFirst('.notify-me-btn', productContainer);
    const notifyMeDesc = queryFirst('.notify-me-desc', productContainer);
    const availabilityMessageEl = queryFirst('.product-availability', productContainer);
    const isPDPPage = queryFirst('.product-detail');
    const mainImageEle = queryFirst('.primary-images .MagicZoom img', productContainer);
    const hiddenClass = 'd-none';
    const { available, isNotifyMeEnabled, id, forceOutOfStock, imageData } = productData;
    if (!available && isNotifyMeEnabled && !forceOutOfStock) {
        addClass(addToCartSection, hiddenClass);
        if (availabilityMessageEl) {
            addClass(availabilityMessageEl, hiddenClass);
        }
        removeClass([notifyMeDesc, notifyMeButton], hiddenClass);
        const notifyImageElement = queryFirst('.notify-product-img img', notifyContainer);
        if (imageData && notifyImageElement) {
            const { alt, url, srcset, src } = isPDPPage ? mainImageEle : imageData[0];
            const imageHasLoaded = hasClass(notifyImageElement, 'lz-loaded');

            notifyImageElement.setAttribute(imageHasLoaded ? 'src' : 'data-src', isPDPPage ? src : url);
            notifyImageElement.setAttribute(imageHasLoaded ? 'srcset' : 'data-srcset', srcset);
            notifyImageElement.setAttribute('alt', alt);
        }
        const notifySize = queryFirst('.notify-size', notifyContainer);
        const notifySizeSeperator = queryFirst('.size-seperator', notifyContainer);
        const notifySelectedSize = queryFirst('.selected-size', notifyContainer);
        queryFirst('.size-label', notifySize).textContent = queryFirst('.size-display-name', productContainer).value;
        queryFirst('.selected-size', notifySize).textContent = queryFirst('.size-btn.selected', productContainer).dataset.attrValue;
        removeClass(notifySizeSeperator, 'd-none');
        removeClass(notifySelectedSize, 'd-none');
        if (id) {
            queryFirst('.notify-pid', notifyContainer).value = id;
        }
        const custEmail = (document.getElementById('notifyEmail') || {}).value;
        if (custEmail) {
            queryFirst('.notify-email', notifyContainer).value = custEmail;
        }
        removeClass(queryFirst('.notify-me-desc', notifyContainer), hiddenClass);
        removeClass(queryFirst('.notify-form', notifyContainer), hiddenClass);
        addClass(queryFirst('.notify-me-confirm', notifyContainer), hiddenClass);
        addClass(queryFirst('.footer-close-link', notifyContainer), hiddenClass);

        $body.trigger('product:notifyMeShown', productContainer);
    } else {
        removeClass(addToCartSection, hiddenClass);
        if (availabilityMessageEl) {
            removeClass(availabilityMessageEl, hiddenClass);
        }
        addClass([notifyMeDesc, notifyMeButton], hiddenClass);

        $body.trigger('product:notifyMeHidden', productContainer);
    }
}

/**
 * Function to toggle select color or size info
 * @param {HTMLElement} productContainer - current product element
 */
function toggleSelectSizeInfo(productContainer) {
    const selectedSizeEl = queryFirst('.size-btn.selected', productContainer);
    const availabilityMessageEl = queryFirst('.select-size-message', productContainer);
    if (availabilityMessageEl) {
        if (!selectedSizeEl) {
            removeClass(availabilityMessageEl, 'd-none');
            availabilityMessageEl.innerHTML = selectStyleMessageTmpl(availabilityMessageEl.dataset.selectStylesMessage);
        }
    }

    if (isShippingPreferencesViewEnabled()) {
        const ispuAvailabilityMessageEl = queryFirst('.ispu-preference-container .select-size-info-msg', productContainer);
        if (ispuAvailabilityMessageEl) {
            const messages = getNestedValue(window, 'johnnyWasUtils.shippingPreferencesConfig.messages') || {};
            const { selectStylesMessage } = messages;
            if (!selectedSizeEl && selectStylesMessage) {
                ispuAvailabilityMessageEl.innerHTML = ispuSelectStyleMessageTmpl(selectStylesMessage);
            }
        }
    }
}
/**
 * Helper method to check if product is on early access or not
 * @param {Object|String} earlyAccess - product | early access date
 * @return {Boolean} true, if early access product or false for not
 */
function isEarlyAccessElement(earlyAccess) {
    let isEarlyAccessItem = false;
    const earlyAccessDate = earlyAccess && earlyAccess.earlyAccessUntilDate || earlyAccess;
    if (earlyAccessDate && earlyAccessDate !== 'false') {
        if (new Date(earlyAccessDate).getTime() > new Date().getTime()) {
            isEarlyAccessItem = true;
        }
    }
    return isEarlyAccessItem;
}

/**
 * Method to show quickbuy size option on hover for Desktop and click for Mobile
 * @param {string} element - container element name
 */
const imageAndQuickbuyHoverHandler = (element) => {
    if ($(element).length) {
        if (matchesBreakpoint('lg')) {
            $(`${element} .image-container`).hover(function () {
            }, function (e) {
                var fitSelect = (e.target.closest('.non-color-list'));
                if (!hasClass(e.target, 'fitSize-value') && !fitSelect) {
                    $(this).find('.quickbuy-btn').css('opacity', '');
                    $(this).find('.quick-buy').addClass('d-none');
                }
            });
        }

        $(`${element} .image-container .quickbuy-btn`).on('mouseover', function () {
            $(this).css('opacity', '0');
            $(this).parent().find('.quick-buy').removeClass('d-none');
        });

        $(element).on('click', '.quickbuy-btn.qmob', function (e) {
            e.preventDefault();
            $('#' + $(this).data('product-id')).modal('show');
            $('.quick-buy-add-toast').attr('is-quick-buy', true);
        });
    }
};

/**
 * Method to handle switching images on hover for product tiles for Desktop
 * @param {elemnt} imageEl - image element
 */
const tileImageHoverHandler = (imageEl) => {
    if (hasClass(imageEl, 'js-plp-image') && window.matchMedia('(hover: hover)').matches) {
        const imageParentEl = imageEl.parentElement;
        const targetEl = imageParentEl.tagName.toLowerCase() === 'picture' ? queryFirst('source[media="(min-width: 1025px)"]', imageParentEl) : imageEl;
        const originalSrc = imageEl.getAttribute('src');
        const originalSrcset = targetEl.getAttribute('srcset');
        const hoverSrcset = imageEl.dataset.hoverSrcset;

        if (hoverSrcset && originalSrcset) {
            imageEl.addEventListener('mouseover', () => {
                imageEl.src = '';
                targetEl.srcset = hoverSrcset;
            });

            imageEl.addEventListener('mouseout', () => {
                imageEl.src = originalSrc;
                targetEl.srcset = originalSrcset;
            });
        }
    }
};
/**
 * Observes video visibility and smartly controls autoplay or pause with hysteresis thresholds.
 * @param {elemnt} videoEl - video element
 */
const autoPlayPauseOnVisibility = (videoEl) => {
    // Stores the desired playback state for each video element
    const desiredPlaybackState = new WeakMap();

    const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(async (entry) => {
            const video = entry.target;

            // Hysteresis thresholds to avoid rapid play/pause toggling
            const shouldPlay = entry.isIntersecting && entry.intersectionRatio >= 0.6;
            const shouldPause = !entry.isIntersecting || entry.intersectionRatio < 0.4;

            // Prevent redundant play/pause calls if state hasn’t changed
            const previousState = desiredPlaybackState.get(video);
            if (previousState === true && shouldPlay) return;
            if (previousState === false && shouldPause) return;

            if (shouldPlay) {
                desiredPlaybackState.set(video, true);

                // Ensure mobile autoplay compatibility
                video.muted = true;
                video.setAttribute('playsinline', '');

                try {
                    if (video.paused) {
                        const playPromise = video.play();
                        if (playPromise && typeof playPromise.then === 'function') {
                            await playPromise;
                        }
                    }
                } catch (err) {
                    // Ignore AbortError (play interrupted by another action)
                    if (err && err.name !== 'AbortError') {
                        console.warn('Autoplay failed:', err);
                        // Fallback: show native video controls
                        video.setAttribute('controls', '');
                    }
                }
            } else if (shouldPause) {
                desiredPlaybackState.set(video, false);
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }, {
        threshold: [0, 0.4, 0.6, 1], // Multiple thresholds for smoother detection
        rootMargin: '0px 0px -10% 0px' // Reduce visible area margin at the bottom
    });

    videoObserver.observe(videoEl);
};

module.exports = {
    toggleSelectSizeInfo: toggleSelectSizeInfo,
    isEarlyAccessElement: isEarlyAccessElement,
    isShippingPreferencesViewEnabled: isShippingPreferencesViewEnabled,
    handleNotifyMe: handleNotifyMe,
    imageAndQuickbuyHoverHandler: imageAndQuickbuyHoverHandler,
    tileImageHoverHandler: tileImageHoverHandler,
    autoPlayPauseOnVisibility: autoPlayPauseOnVisibility
};

